// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#33058d","colorSecondary":"#9df894","colorConfirmed":"#9df894","colorPending":"#facd90","colorDeclined":"#ff637d","textPrimary":"#353535"};